var map = {
	"./007-microphone-1.png": 544,
	"./010-home.png": 545,
	"./013-document-1.png": 546,
	"./014-document.png": 547,
	"./015-color-palette.png": 548,
	"./017-video-camera.png": 549,
	"./024-like.svg": 1220,
	"./1.svg": 1221,
	"./155-credit-card.svg": 1222,
	"./2.svg": 1223,
	"./3.svg": 1224,
	"./4.svg": 1225,
	"./New Customer.svg": 1226,
	"./NotOpen.svg": 1227,
	"./Opened.svg": 1228,
	"./Profit.svg": 1229,
	"./SalesRevenue.svg": 1230,
	"./Sent.svg": 1231,
	"./Slack.svg": 1232,
	"./address.svg": 1233,
	"./adobe.svg": 1234,
	"./arrow-left.svg": 1235,
	"./arrow-right.svg": 1236,
	"./book.svg": 1237,
	"./camera.svg": 1238,
	"./chat.svg": 1239,
	"./click.svg": 647,
	"./clipboard.svg": 1240,
	"./cloud.svg": 1241,
	"./columns.svg": 1242,
	"./documentation.svg": 1243,
	"./file.svg": 1244,
	"./filters-check-icon.svg": 592,
	"./flat.svg": 1245,
	"./headphone.svg": 1246,
	"./iconfinder_trello_2317760.svg": 1247,
	"./idea.svg": 1248,
	"./image.png": 550,
	"./image.svg": 1249,
	"./inbox.svg": 1250,
	"./label.png": 551,
	"./layers.svg": 1251,
	"./left.svg": 1252,
	"./logo2.svg": 1253,
	"./logo3.svg": 1254,
	"./logo4.svg": 1255,
	"./logo5.svg": 1256,
	"./logo6.svg": 1257,
	"./logoIn.svg": 1258,
	"./pagination-arrow-left.svg": 1259,
	"./pagination-arrow-right.svg": 1260,
	"./paint.svg": 1261,
	"./protection.svg": 1262,
	"./quote.png": 552,
	"./remove.png": 553,
	"./repeat.svg": 1263,
	"./right.svg": 1264,
	"./shop-check.svg": 648,
	"./strategy.svg": 1265,
	"./success-image.png": 440,
	"./theme.svg": 1266,
	"./user.svg": 1267,
	"./water-fall.svg": 1268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1219;